import Flats from './Flats';

export default Flats;



// WEBPACK FOOTER //
// ./src/components/FlatsList/Flats/index.js